import { render, staticRenderFns } from "./SwitchChallengeMethod.vue?vue&type=template&id=59e83d59&scoped=true"
import script from "./SwitchChallengeMethod.vue?vue&type=script&lang=js"
export * from "./SwitchChallengeMethod.vue?vue&type=script&lang=js"
import style0 from "./SwitchChallengeMethod.vue?vue&type=style&index=0&id=59e83d59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e83d59",
  null
  
)

export default component.exports